"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Options;
exports.filterOptions = void 0;
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  Option
} = _antd.Select;
function Options(options = [], includeAll = false) {
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, includeAll && /*#__PURE__*/_react.default.createElement(Option, {
    value: ""
  }, "All"), options.filter(option => {
    return option.label !== null;
  }).map(option => {
    if (typeof option === 'object') {
      return /*#__PURE__*/_react.default.createElement(Option, {
        key: option.value,
        value: option.value
      }, option.label);
    } else {
      return /*#__PURE__*/_react.default.createElement(Option, {
        key: option,
        value: option
      }, option);
    }
  }));
}
const filterOptions = (input, option) => {
  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
exports.filterOptions = filterOptions;
//# sourceMappingURL=options.js.map